import { AxiosResponse } from 'axios';
import root from '../root';
import v3 from '../v3';
import v4 from '../v4';

export interface IPointToPhoto {
  _id: string;
  creator?: {
    cert?: { name: string },
  };
  photo: string;
  removed: boolean;
  updatedAt: Date;
  location: {
    geometry: GeoJSON.Point;
    gcj02Geometry: GeoJSON.Point;
  };
  createdAt: Date;
  type: number;
  processed: boolean;
  address: string;
}

export interface IPhotoImage {
  cdnUrl: string;
  name: string;
  signedUrl: string;
  url: string;
}

export async function findNear(center: ILngLat, radius: number, isGcj: boolean): Promise<AxiosResponse<IPointToPhoto[]>> {
  return await v4({
    url: `operation.photoToPoint/byLocation`,
    params: {
      center,
      radius,
      isGcj,
      selector: 'creator photo location parkingLot type processed createdAt',
      populateSelector: {
        creator: 'cert.name',
      },
    },
  });
}

export async function create(coordinates: ILngLat, photo: string, isGcj: boolean): Promise<AxiosResponse<IPointToPhoto>> {
  return await v3({
    url: 'operation.photoToPoint',
    method: 'post',
    data: { coordinates, photo, isGcj },
  });
}

export async function remove(id: string): Promise<void> {
  await v3({
    url: `operation.photoToPoint/id/${id}`,
    method: 'delete',
  });
}

export async function uploadPhoto(file: File): Promise<AxiosResponse<IPhotoImage>> {
  const form = new FormData();
  form.append('file', file);
  return root({
    url: '/oss/photoToPoint',
    method: 'post',
    data: form,
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/pointToPhoto.ts